const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'postbookingpage_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    options: {
    },

    methods: {
        loginOk(data) {
            this.model.set('userDTO', data.userDTO);
            if (this.model.isMobile()) {
                this.model.set('eventType', 'signin');
            } else {
                this.model.set('eventType', 'start');
            }
        },
        setUserType(userType) {
            this.model.set('userType', userType);
        },
        recaptchaLoaded() {
            this.model.getRecaptchaConfig();
        },
        registerOk(data) {
            this.model.set('userDTO', data.userDTO);
            this.model.set('eventType', 'register');
            this.model.trackEvent('register');
        },
        registerKO() {
            this.model.set('eventType', 'register');
            this.displayErrorPage();
        },
        displayErrorPage() {
            this.model.set('displayErrorPage', true);
        },
        trackPage(label) {
            this.model.trackPage(label);
        },
    },

});
